import {  useState , useEffect } from 'react'
import useProductsIDs from 'newHooks/useProductsIDs'
import { BASE_PATH_API } from 'constants/env'

const productArray = (product) => {
    const idsProduct = product.map( ids => Number(ids?.product_sears_id) || Number(ids?.external_id) )
    return idsProduct
}

const useCartProducts = () => {
    const {
        getProductsByFilter,
        responseProduct
    } = useProductsIDs()

    const [ cartID, setCartID ] = useState(false)
    const [ listCarts, setListCarts ] = useState(false)
    const [ initProducts, setInitProducts ] = useState([])
    const [ products, setProducts ] = useState([])
    const [ responseTable, setResponseTable ] = useState(false)
    const [ firstTime, setFirstTime ] = useState(true)

    const getEventTable = async (eventID) => {
        const idsFilter = String(eventID)
        try {
            const response = await fetch(`${BASE_PATH_API}/gift-table/v1/gift-table/${idsFilter}?is_guest=true`);
            const data = await response.json();
            setResponseTable(data?.data)
        } catch (error) {
            console.error('Error fetching getEventTable data:', error);
        }
    }

    const [ preResp, setPreResp ] = useState([])
    useEffect(()=>{
        if(listCarts){
            if(listCarts?.length >= 1){
                if(listCarts[0]?.products){
                    setCartID(listCarts[0]?.cart_id)
                    const productsA = listCarts[0]?.products
                    if(firstTime){
                        getProductsByFilter( productArray(productsA) ) 
                    }
                    else if(!firstTime && ( preResp !== productsA?.length) ){
                        const initArray = productArray(initProducts)
                        const respArray = productArray(productsA)
                        const diffIDS = Number( initArray.filter(item => !respArray.includes(item)) )
                        const respDelete = initProducts.filter(product => product?.external_id !== diffIDS)
                        setPreResp(preResp - 1)
                        setInitProducts( respDelete )
                        setProducts( respDelete )
                    }
                }
            }else{
                setProducts([])
            }
        }
    },[ listCarts ])

    useEffect(()=>{
        if(responseProduct){
            setFirstTime(false)
            if(responseProduct?.length >= 1){
                const newResponse = listCarts[0]?.products
                const responseMerge = responseProduct.map(productMerge => {
                    const gifts = newResponse.filter(gift => gift.product_sears_id === productMerge?.id)[0]
                    const amount = gifts?.quantity
                    const quantity_for_gift = gifts?.quantity_required
                    const variantSelected = gifts?.children_sku_sears ? gifts?.children_sku_sears : []
                    const variant_id = gifts?.variant_sears_id ? gifts?.variant_sears_id : null
                    const fusion = {
                        ...productMerge,
                        amount,
                        quantity_for_gift,
                        variantSelected,
                        variant_id
                    }
                    return fusion
                })
                setProducts( responseMerge ) 
                setInitProducts( responseMerge )
                setPreResp(responseMerge?.length)
            }
        }
    },[responseProduct])

    return{
        cartID,
        products,
        setListCarts,
        getEventTable,
        responseTable
    }
}


export default useCartProducts